module.exports = __webpack_public_path__ + "img/upload.92df6a45.svg";